"use strict";
exports.__esModule = true;
exports.starPath = void 0;
exports.starPath = "polygon(\n    50% 0%,\n    63% 38%,\n    100% 38%,\n    69% 59%,\n    82% 100%,\n    50% 75%,\n    18% 100%,\n    31% 59%,\n    0 38%,\n    37% 38%\n  );\n  ";
